import { ACT_USR_CHANGE } from "../actions/ActionTypes";

const initialState = {
	userList:[]
};

export default function(state = initialState, action) {
	if (action.type === ACT_USR_CHANGE) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/UserReducer.js